import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";
import { Navbar, Container, NavDropdown, DropdownButton } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import mobileLogo from '../images/mobile_logo.svg';
import { clearLocalStorageItems } from './common/Functions';

interface SimpleHeaderProps {
  title?: string;
  logo?: string;
  setGroups?: (groups: string[]) => void;
}

const SimpleHeader: React.FC<SimpleHeaderProps> = (props) => {
  const { user, logout } = useAuth0();
  const [groups, setGroups] = useState<string[]>([]);
  const [formattedDate, setFormattedDate] = useState<string>("");
  const [timeOfDay, setTimeOfDay] = useState<string>("");
  const navigate = useNavigate();

  const location = useLocation();
  const [dropdownTitle, setDropdownTitle] = useState<string>('Dropdown');

  useEffect(() => {
    if (user !== null) {
      const userRoles = user?.ept_roles as string[] | undefined;
      if (userRoles) {
        setGroups(userRoles);
        if (props.setGroups !== undefined) {
          props.setGroups(userRoles);
        }
      }
    }
  }, [user, props]);

  useEffect(() => {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleDateString(undefined, { month: 'long' });

    // Function to add 'st', 'nd', 'rd', or 'th' to the day
    const getDayWithOrdinal = (day: number): string => {
      if (day >= 11 && day <= 13) {
        return `${day}th`;
      }
      switch (day % 10) {
        case 1:
          return `${day}st`;
        case 2:
          return `${day}nd`;
        case 3:
          return `${day}rd`;
        default:
          return `${day}th`;
      }
    };

    const formattedDayName = date.toLocaleDateString(undefined, { weekday: 'long' });
    const formattedDay = getDayWithOrdinal(day);
    const formattedYear = date.getFullYear();

    const hours = date.getHours();

    // Determine time of day based on hours
    let timeOfDayText: string = '';
    if (hours >= 5 && hours < 12) {
      timeOfDayText = 'Morning';
    } else if (hours >= 12 && hours < 17) {
      timeOfDayText = 'Afternoon';
    } else if (hours >= 17 && hours < 21) {
      timeOfDayText = 'Evening';
    } else {
      timeOfDayText = 'Night';
    }

    setTimeOfDay(timeOfDayText);

    const formattedDateStr = `${formattedDayName}, ${month} ${formattedDay}, ${formattedYear}`;
    setFormattedDate(formattedDateStr);
  }, []);

  return (
    <div>
      <Navbar className='ept-header'>
        <Container fluid="xxl">
          <Navbar.Brand className='newtimeandwave'>
          {props.title && (
            <span>{props.title}</span>
          )}
          </Navbar.Brand>
          <Navbar.Brand className='mobile-logo'>
            <img src={props.logo || mobileLogo} alt="Mobile Logo" />
          </Navbar.Brand>
          <Navbar.Toggle />
          <div className='mobile-menu'>
            <DropdownButton title={dropdownTitle} id="mobile-menu">
              <Link to="/" className={`ask-btn ${location.pathname === '/' ? 'active' : ''}`}>
                  <span>Ask a question</span>
              </Link>
              <Link to="/community-forum" className={`community-btn ${location.pathname === '/community-forum' ? 'active' : ''}`}>
                    <span>Community Forum</span>
              </Link>
            </DropdownButton>
          </div>
          
        </Container>
      </Navbar>
    </div>
  );
}

export default SimpleHeader;

